



























import { Component, Prop, Vue } from 'vue-property-decorator';
import { OptimizerRecommendation } from '../types';

@Component
export default class OptimizationHint extends Vue {
  @Prop(Object) recommendation!: OptimizerRecommendation;
  @Prop({ type: Boolean, default: false }) disabled!: boolean;
  @Prop({ type: String, default: '' }) disabledTip!: string;
  @Prop({ type: Boolean, default: true }) inset!: boolean;
}
